import bachoSaginashviliAvatar from "./assets/athletes/bachoSaginashvili.png";
import mamukaAvatar from "./assets/athletes/mamuka.png";
import nugoChikadzeAvatar from "./assets/athletes/nugoChikadze.png";
import bachoDighmelashviliAvatar from "./assets/athletes/bachoDighmelashvili.png";
import otoSaginashviliAvatar from "./assets/athletes/otarSaginashvili.png";
import giorgiRostomashviliAvatar from "./assets/athletes/giorgiRostomashvili.png";
import mikheilGelovaniAvatar from "./assets/athletes/mikheilGelovani.png";
import nikaKuzanashviliAvatar from "./assets/athletes/nikaKuzanashvili.png";
import merabiAlugishviliAvatar from "./assets/athletes/merabiAlugishvili.png";
import girgiDighmelashviliAvatar from "./assets/athletes/girogiDighmelashvili.png";
import giorgiDigmelashviliKhuchuchaAvatar from "./assets/athletes/giorgiDighmelashvili-khuchucha.png";
import alekoKevlishviliAvatar from "./assets/athletes/alekoKevlishvili.png";
import valeriKeratishviliAvatar from "./assets/athletes/valeriKeratishvili.png";
import giorgiGhvnashviliAvatar from "./assets/athletes/giorgiGhvinashvili.png";
import otarSaginashviliAvatar from "./assets/athletes/otoSaginashvili.png";

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  `https://api-staging.awcgarejelebi.com/api`;
export const PAYPAL_CLIENT_ID =
  process.env.REACT_APP_PAYPAL_CLIENT_ID ||
  "AZ2bni3eMrkcWRKhZYRj2xKtOOyKeBwyJe4GbW9UcortNxkph3LEp9kQcvExSmfpzMggFONptrq8gsNj";

export const TABLIST = [
  "Home",
  // "Trainings",
  "Onlinecourses",
  "Athletes",
  "Shop",
  "About",
  // "Blogs",
  "Contact",
];
export const coach = {
  id: 1,
  name: "Mamuka Bilanishvili",
  description:
    "Renowned Georgian arm wrestling coach and a founder of the AWC Garejelebi.",
  image: mamukaAvatar,
  details: [
    "Mamuka Bilanishvili is a highly respected figure in the arm wrestling community, celebrated as both a coach and a mentor. As a coach at AWC Garejelebi, he has played a pivotal role in training top-tier athletes, including the Saginashvili brothers, Bacho and Otar. Known for his expertise and dedication, Mamuka has been instrumental in nurturing the next generation of champions, building a legacy of excellence in the sport. His training methods and leadership have earned him recognition internationally, and he continues to inspire athletes with his passion and strategic approach to arm wrestling.",
  ],
  social: {
    facebook: "https://www.facebook.com/bilanishvilimamuka",
    instagram: "https://www.instagram.com/mbilanishvili/",
  },
};

export const ATHLETES = [
  {
    id: 1,
    name: "Bacho Saginashvili",
    description: "A dominant force in multiple age categories.",
    image: bachoSaginashviliAvatar,
    details: [
      "East vs West - 2X Winner",
      "2023 European Championship - Gold Medal, Left & Right Arm (Youth +90kg)",
      "2023 European Championship - Bronze Medal, Right Arm (Senior 100kg)",
      "2019 European Championship - Gold Medal, Left & Right Arm (Sub Junior +70kg)",
      "2019 World Championship - Gold Medal, Left & Right Arm (Sub Junior +70kg)",
    ],
    social: {
      instagram: "https://www.instagram.com/saginashvilibacho/",
    },
  },
  {
    id: 2,
    name: "Nugo Chikadze",
    description: "A skilled youth and senior arm wrestler.",
    image: nugoChikadzeAvatar,
    details: [
      "2023 European Championship - Gold Medal, Right Arm (Senior 100kg)",
      "2019 World Championship - Gold Medal, Right Arm (Youth 90kg)",
      "2019 World Championship - Silver Medal, Left Arm (Youth 90kg)",
      "2019 European Championship - Silver Medal, Left Arm (Youth 90kg)",
      "2019 European Championship - Gold Medal, Right Arm (Youth 90kg)",
      "2018 World Championship - Gold Medal, Right Arm (Youth 80kg)",
      "2018 European Championship - Gold Medal, Right Arm (Youth 80kg)",
    ],
    social: {
      instagram: "https://www.instagram.com/chikadzenugo/",
    },
  },
  {
    id: 3,
    name: "Otari Saginashvili",
    description: "Dominant competitor in junior and youth categories.",
    image: otarSaginashviliAvatar,
    details: [
      "2023 European Championship - Gold Medal, Left Arm (Youth 90kg)",
      "2023 European Championship - Bronze Medal, Right Arm (Youth 90kg)",
      "2023 World Championship - Bronze Medal, Left Arm (Youth 90kg)",
      "2019 World Championship - Gold Medal, Left Arm (Junior 80kg)",
      "2019 World Championship - Gold Medal, Right Arm (Junior 80kg)",
      "2019 European Championship - Gold Medal, Left Arm (Junior 80kg)",
      "2019 European Championship - Silver Medal, Right Arm (Junior 80kg)",
    ],
    social: {
      instagram: "https://instagram.com/",
    },
  },
  {
    id: 4,
    name: "Bacho Dighmelashvili",
    description: "A consistent winner in junior and sub-junior categories.",
    image: bachoDighmelashviliAvatar,
    details: [
      "2024 European Championship - Gold Medal, Left & Right Arm (Junior 80kg)",
      "2024 World Championship - Gold Medal, Left & Right Arm (Junior 80kg)",
      "2023 World Championship - Silver Medal, Left & Right Arm (Sub Junior +70kg)",
      "2023 European Championship - Gold Medal, Left & Right Arm (Sub Junior +70kg)",
    ],
    social: {
      instagram: "https://www.instagram.com/bachidigmelashvili/",
    },
  },
  {
    id: 5,
    name: "Otari Saginashvili",
    description: "A strong junior competitor in arm wrestling.",
    image: otoSaginashviliAvatar,
    details: [
      "2024 World Championship - Bronze Medal, Right Arm (Junior 65kg)",
      "2024 European Championship - Gold Medal, Right Arm (Junior 65kg)",
    ],
    social: {
      instagram: "https://www.instagram.com/saginashvilio/",
    },
  },
  {
    id: 6,
    name: "Mikha Gelovani",
    description: "A promising junior arm wrestler.",
    image: mikheilGelovaniAvatar,
    details: [
      "2024 World Championship - Silver Medal, Right Arm (Junior 75kg)",
    ],
    social: {
      instagram: "https://instagram.com/",
    },
  },
  // {
  //   id: 7,
  //   name: "Giorgi Kevlishvili",
  //   description: "A strong competitor in junior arm wrestling.",
  //   image: "giorgiKevlishviliAvatar",
  //   details: [
  //     "2019 European Championship - Bronze Medal, Left Arm (Junior 50kg)",
  //     "2019 European Championship - Silver Medal, Right Arm (Junior 50kg)",
  //     "2019 World Championship - Silver Medal, Left Arm (Junior 50kg)",
  //   ],
  //   social: {
  //     instagram: "https://instagram.com/",
  //   },
  // },
  {
    id: 8,
    name: "Giorgi Digmelashvili",
    description: "A top performer in junior arm wrestling competitions.",
    image: girgiDighmelashviliAvatar,
    details: [
      "2019 World Championship - Gold Medal, Left Arm (Junior 70kg)",
      "2019 European Championship - Gold Medal, Left Arm (Junior 70kg)",
      "2019 European Championship - Bronze Medal, Right Arm (Junior 70kg)",
    ],
    social: {
      instagram: "https://instagram.com/",
    },
  },

  {
    id: 9,
    name: "Giorgi Digmelashvili Khuchucha",
    description: "Rising star in junior arm wrestling.",
    image: giorgiDigmelashviliKhuchuchaAvatar,
    details: [
      "2024 European Championship - Silver Medal, Left Arm (Junior 75kg)",
      "2024 European Championship - Bronze Medal, Right Arm (Junior 75kg)",
      "2023 World Championship - Bronze Medal, Right Arm (Junior 75kg)",
    ],
    social: {
      instagram: "https://instagram.com/",
    },
  },

  {
    id: 10,
    name: "Giorgi Rostomashvili",
    description: "A senior competitor with impressive achievements.",
    image: giorgiRostomashviliAvatar,
    details: [
      "2024 European Championship - Silver Medal, Right Arm (Senior +110kg)",
      "2023 European Championship - Gold Medal, Right Arm (Senior +110kg)",
      "2018 European Championship - Silver Medal, Left Arm (Senior 100kg)",
      "2017 World Championship - Silver Medal, Left Arm (Senior 100kg)",
    ],
    social: {
      instagram: "https://www.instagram.com/giorgi.rostomashvili.9028/",
    },
  },

  {
    id: 11,
    name: "Nika Kuzanashvili",
    description: "A young competitor making his mark.",
    image: nikaKuzanashviliAvatar,
    details: ["2024 World Championship - Bronze Medal, Right Arm (Youth 65kg)"],
    social: {
      instagram: "https://instagram.com/",
    },
  },
  {
    id: 12,
    name: "Aleko Kevlishvili",
    description: "A skilled sub-junior arm wrestler.",
    image: alekoKevlishviliAvatar,
    details: [
      "2024 European Championship - Gold Medal, Left Arm (Sub Junior 50kg)",
      "2024 European Championship - Silver Medal, Right Arm (Sub Junior 50kg)",
    ],
    social: {
      instagram: "https://www.instagram.com/alekokevlishvilii/",
    },
  },
  {
    id: 13,
    name: "Merabi Alugishvili",
    description: "A strong competitor in para arm wrestling.",
    image: merabiAlugishviliAvatar,
    details: [
      "2024 European Championship - Gold Medal, Left & Right Arm (Para Armwrestling +65kg)",
      "2024 World Championship - Silver Medal, Left Arm (Para Armwrestling +65kg)",
      "2024 World Championship - Bronze Medal, Right Arm (Para Armwrestling +65kg)",
    ],
    social: {
      instagram: "https://instagram.com/",
    },
  },
  {
    id: 14,
    name: "Valeri Keratishvili",
    description: "A competitive junior arm wrestler.",
    image: valeriKeratishviliAvatar,
    details: [
      "2023 European Championship - Bronze Medal, Left & Right Arm (Junior +90kg)",
    ],
    social: {
      instagram: "https://instagram.com/",
    },
  },
  {
    id: 15,
    name: "Giorgi Gvinashvili",
    description: "A strong performer in junior arm wrestling.",
    image: giorgiGhvnashviliAvatar,
    details: [
      "2024 European Championship - Gold Medal, Left Arm (Junior 75kg)",
      "2024 European Championship - Bronze Medal, Right Arm (Junior 75kg)",
      "2023 World Championship - Silver Medal, Right Arm (Junior 75kg)",
    ],
    social: {
      instagram: "https://instagram.com/",
    },
  },
];

export const EQUIPMENTS = [
  {
    id: 1,
    name: "Arm Wrestling Table",
    description:
      "Professional arm wrestling table with padded elbow and hand grips.",
    price: 10.99,
    image: "https://picsum.photos/100",
  },
  {
    id: 2,
    name: "Grip Strengthener",
    description:
      "Adjustable grip strengthener for improving hand and forearm strength.",
    price: 7.99,
    image: "https://picsum.photos/200",
  },
  {
    id: 3,
    name: "Resistance Bands",
    description:
      "Set of resistance bands for strength training and rehabilitation.",
    price: 15.99,
    image: "https://picsum.photos/300",
  },
  {
    id: 4,
    name: "Wrist Wraps",
    description:
      "High-quality wrist wraps for added support during arm wrestling.",
    price: 11.99,
    image: "https://picsum.photos/400",
  },
  {
    id: 5,
    name: "Arm Wrestling Chalk",
    description: "Premium gym chalk for a better grip during arm wrestling.",
    price: 4.99,
    image: "https://picsum.photos/500",
  },
];

export const COUNTRIES = [
  { name: "Brazil", flag: "🇧🇷" },
  { name: "Canada", flag: "🇨🇦" },
  { name: "Czechia", flag: "🇨🇿" },
  { name: "Egypt", flag: "🇪🇬" },
  { name: "Finland", flag: "🇫🇮" },
  { name: "France", flag: "🇫🇷" },
  { name: "Georgia", flag: "🇬🇪" },
  { name: "Hong Kong (China)", flag: "🇭🇰" },
  { name: "Israel", flag: "🇮🇱" },
  { name: "Italy", flag: "🇮🇹" },
  { name: "Mexico", flag: "🇲🇽" },
  { name: "Spain", flag: "🇪🇸" },
  { name: "Sweden", flag: "🇸🇪" },
  { name: "Thailand", flag: "🇹🇭" },
  { name: "United States", flag: "🇺🇸" },
  { name: "Portugal", flag: "🇵🇹" },
  { name: "Norway", flag: "🇳🇴" },
  { name: "Bulgaria", flag: "🇧🇬" },
];

export const tesetimonials = [
  {
    id: 1,
    name: "Lucas",
    country: "🇧🇷",
    img: "https://picsum.photos/200",
    quote:
      "My name is Lucas, I'm from small town in Brazil, and I just bought the PRO arm wrestlimg course on AWC Garejelebi website. I'm really injoyng it! and I've already cleard up several doubts I had for a long time",
  },
  {
    id: 2,
    name: "Mazio",
    country: "🇮🇹",
    img: "https://picsum.photos/201",
    quote:
      "I wanted to thank you for the information you gave me on how to train. With only two weeks of training I feel a completely new strength. Yesterday I trained with my teammates, much heavier and more muscular than me and despite this I could easily beat almost all of them…",
  },
  {
    id: 3,
    name: "Varuth",
    country: "🇹🇭",
    img: "https://picsum.photos/202",
    quote:
      "This is a very well-structured training plan. I’ve been making steady progress every week. It's an excellent training program",
  },
  {
    id: 4,
    name: "Jeramias",
    country: "🇫🇮",
    img: "https://picsum.photos/203",
    quote:
      "Thank you for the opportunity to join this high-level and demanding training program. I've made noticeable progress in a short time — especially at the armwrestling table, where I feel much stronger and more confident. I'm very happy with the results and overall experience",
  },
  {
    id: 5,
    name: "Pranav",
    country: "🇺🇸",
    img: "https://picsum.photos/204",
    quote:
      "Thank you guys again for the coaching and the calls! I’m excited for the progress and good luck to your team at the championship 💪",
  },
  {
    id: 6,
    name: "Bariel",
    country: "🇮🇱",
    img: "https://picsum.photos/205",
    quote:
      "The program is great and truly delivers results — I’ve definitely gotten stronger. The consults were excellent, and it’s clear you’re professionals. The first weekly training is quite intense, lasting around 4–4.5 hours with 4–5 sets, which might be too much for some.",
  },
];
